import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

type BrowserAgentParameters = ConstructorParameters<typeof BrowserAgent>[0];

const agentConfig: BrowserAgentParameters = {
  info: {
    applicationID: process.env.BROWSER_NEW_RELIC_APPLICATION_ID ?? "",
    licenseKey: process.env.BROWSER_NEW_RELIC_LICENSE_KEY ?? "",
    sa: 1
  },
  loader_config: {
    agentID: process.env.BROWSER_NEW_RELIC_AGENT_ID ?? ""
  },
  init: {
    distributed_tracing: {
      enabled: true
    },
    privacy: {
      cookies_enabled: true
    }
  }
};

let agent: BrowserAgent | null = null;

export function initializeNewRelic(): BrowserAgent | null {
  if (!agent) {
    if (!agentConfig.info.applicationID) {
      console.error(
        "Invalid values for New Relic configuration. ApplicationID is missing and New Relic will not be initialized."
      );
      return null;
    }
    if (!agentConfig.info.licenseKey) {
      console.error(
        "Invalid values for New Relic configuration. LicenseKey is missing and New Relic will not be initialized."
      );
      return null;
    }
    if (!agentConfig.loader_config.agentID) {
      console.error(
        "Invalid values for New Relic configuration. AgentID is missing and New Relic will not be initialized."
      );
      return null;
    }
    agent = new BrowserAgent(agentConfig);
    window.newrelic = agent;
  }

  return agent;
}
